import Dropdown from "react-bootstrap/Dropdown";

function LanguageOptions() {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="warning" id="language-options">
        Sprache auswählen
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="/ch/Home">German</Dropdown.Item>
        <Dropdown.Item href="/uk/ch/Home">English</Dropdown.Item>
        <Dropdown.Item href="/fr/ch/Home">French</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LanguageOptions;
